import { render, staticRenderFns } from "./Parceria.vue?vue&type=template&id=99d5df4e&"
import script from "./Parceria.vue?vue&type=script&lang=js&"
export * from "./Parceria.vue?vue&type=script&lang=js&"
import style0 from "./Parceria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports